<!--
검수에 사용되는 검수요청사항 컴포넌트
------------------------------------
-->
<template>
    <div
        v-html="requestBr"
        class="uk-card-header uk-text-large uk-text-left"
        :class="requestClass"
        v-on:click="checked = ! checked"
        title="click to check"
    >

    </div>
</template>

<script>
    export default {
        props: {
            // 검수요청사항
            request: String,
        },
        data: function () {
            return {
                // 선택여부
                checked: false,
            };
        },
        computed: {
            /**
             * class name
             * @returns {string}
             */
            requestClass: function () {
                return this.checked ? 'check' : 'uncheck';
            },

            /**
             * br 태그 적용
             * @returns {string}
             */
            requestBr: function () {
                return this.request.replace(/(?:\r\n|\r|\n)/g, '<br />');
            },
        },
        mounted: function () {
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    .uncheck {
        color: #1e87f0 !important;
    }
    .check {
        color: #999 !important;
        text-decoration-line: line-through;
    }
</style>